export const PdfIcon = (props: any) => (
  <svg
    className={props.className}
    width="49"
    height="61"
    viewBox="0 0 49 61"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect
      width="45.4727"
      height="61"
      rx="2.5"
      fill="#E47C6E"
      fillOpacity="0.3"
    />
    <rect
      x="4.91699"
      y="21.0727"
      width="43.4394"
      height="15.6382"
      rx="2.5"
      fill="#E47C6E"
    />
    <path
      d="M23.6032 27.2063C23.6032 27.9289 23.3558 28.4856 22.861 28.8762C22.3694 29.2636 21.6647 29.4572 20.7467 29.4572H19.9069V32.2649H19.0768V25.1262H20.9274C22.7112 25.1262 23.6032 25.8195 23.6032 27.2063ZM19.9069 28.7443H20.6539C21.3896 28.7443 21.9218 28.6255 22.2506 28.3879C22.5794 28.1503 22.7438 27.7694 22.7438 27.2453C22.7438 26.7733 22.5892 26.4218 22.2799 26.1906C21.9707 25.9595 21.4889 25.844 20.8346 25.844H19.9069V28.7443ZM30.8004 28.6272C30.8004 29.8055 30.4798 30.7072 29.8385 31.3322C29.2005 31.954 28.2809 32.2649 27.0797 32.2649H25.1022V25.1262H27.2897C28.3997 25.1262 29.2623 25.4338 29.8776 26.049C30.4928 26.6643 30.8004 27.5236 30.8004 28.6272ZM29.9215 28.6565C29.9215 27.7255 29.6871 27.024 29.2184 26.552C28.7529 26.08 28.0595 25.844 27.1383 25.844H25.9323V31.5471H26.943C27.9326 31.5471 28.6764 31.3046 29.1744 30.8195C29.6725 30.3313 29.9215 29.6102 29.9215 28.6565ZM33.2272 32.2649H32.3971V25.1262H36.3766V25.8635H33.2272V28.4758H36.1862V29.2131H33.2272V32.2649Z"
      fill="white"
    />
  </svg>
);
